/* ==========================================================================
   SANS PEUR — Animations & Scroll Behaviors
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     IntersectionObserver — fade/slide animations
     -------------------------------------------------------------------------- */
  const animatedElements = document.querySelectorAll('[data-animate]');
  const staggerContainers = document.querySelectorAll('[data-stagger]');

  const observerOptions = {
    threshold: 0.12,
    rootMargin: '0px 0px -60px 0px',
  };

  if (animatedElements.length || staggerContainers.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    animatedElements.forEach((el) => observer.observe(el));
    staggerContainers.forEach((el) => observer.observe(el));
  }

  /* --------------------------------------------------------------------------
     Split Text — animate headings letter by letter
     -------------------------------------------------------------------------- */
  function splitText(elements) {
    elements.forEach((el) => {
      const text = el.textContent;
      el.textContent = '';
      el.classList.add('split-text');

      text.split('').forEach((char, i) => {
        const span = document.createElement('span');
        span.className = 'char';
        span.textContent = char === ' ' ? ' ' : char;
        span.style.transitionDelay = `${i * 30}ms`;
        el.appendChild(span);
      });
    });
  }

  const splitElements = document.querySelectorAll('[data-split-text]');
  if (splitElements.length) {
    splitText(splitElements);

    const splitObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          splitObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    splitElements.forEach((el) => splitObserver.observe(el));
  }

  /* --------------------------------------------------------------------------
     Header — transparent → solid on scroll
     -------------------------------------------------------------------------- */
  const header = document.querySelector('.site-header');
  const announcementBar = document.querySelector('.announcement-bar');

  function handleHeaderScroll() {
    const scrollY = window.scrollY;
    const threshold = 50;

    if (header) {
      if (scrollY > threshold) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    // Hide announcement bar on scroll
    if (announcementBar) {
      if (scrollY > 100) {
        announcementBar.style.transform = 'translateY(-100%)';
        if (header) {
          header.style.top = '0';
        }
      } else {
        announcementBar.style.transform = '';
        if (header) {
          header.style.top = '';
        }
      }
    }
  }

  window.addEventListener('scroll', handleHeaderScroll, { passive: true });
  handleHeaderScroll(); // Run on init

  /* --------------------------------------------------------------------------
     Parallax — hero background
     -------------------------------------------------------------------------- */
  const heroBackground = document.querySelector('.hero__background');

  if (heroBackground && window.innerWidth > 768) {
    // Only do JS parallax if background-attachment: fixed is not supported well
    // (e.g., on some mobile browsers)
    function updateParallax() {
      const scrollY = window.scrollY;
      heroBackground.style.transform = `translateY(${scrollY * 0.3}px)`;
    }

    // Only enable JS parallax if not using CSS fixed attachment
    const usesFixedAttachment = getComputedStyle(heroBackground).backgroundAttachment === 'fixed';
    if (!usesFixedAttachment) {
      window.addEventListener('scroll', updateParallax, { passive: true });
    }
  }

  /* --------------------------------------------------------------------------
     Scroll down indicator click
     -------------------------------------------------------------------------- */
  const scrollIndicator = document.querySelector('.hero__scroll-indicator');
  if (scrollIndicator) {
    scrollIndicator.addEventListener('click', () => {
      const heroHeight = document.querySelector('.hero')?.offsetHeight || window.innerHeight;
      window.scrollTo({ top: heroHeight, behavior: 'smooth' });
    });
  }

})();
